export const BRAZILIAN_PORTUGUESE_LOCALE = 'pt-BR';

export const isBrazilianPortuguese = (locale: string) => {
  const [language, region] = locale.toLowerCase().split(/[-_]/);

  return language === 'pt' && region === 'br';
};
